import React, { useState } from "react";
import logo from "../assets/img/logo.svg";
import prev_arrow from "../assets/img/prev_arrow.svg";
import next_arrow from "../assets/img/next_arrow.svg";

const Step4 = ({ setStep, setFormdata, formData, setStep4Status }) => {
  const [idealClientError, setIdealClientError] = useState(false); // Error state for ideal client

  // Handle Next button click
  const handleNext = () => {
    if (!formData?.ideal_client) {
      setIdealClientError(true); // Show error if ideal client is empty
    } else {
      setStep(5); // Proceed to the next step if ideal client is valid
      setStep4Status(true); // Mark step 4 as completed
    }
  };

  return (
    <>
      <div class="top_logo_block">
        <div class="logo">
          <a href="">
            <img src={logo} alt="" />
          </a>
        </div>
      </div>

      <div class="step_body">
        <div class="step_form">
          <div class="form_block box_width_lg_two">
            <h1>Who is your ideal client?</h1>
            <div class="input_fields">
              <textarea
                placeholder="Who is your ideal client?"
                value={formData?.ideal_client || ""}
                onChange={(e) => {
                  setFormdata((prevState) => ({
                    ...prevState,
                    ideal_client: e.target.value, // Update the ideal client field
                  }));
                  setIdealClientError(false); // Clear error on input change
                }}
              ></textarea>
              {idealClientError && (
                <p style={{ color: "red" }}>Ideal client is required.</p>
              )}
            </div>
          </div>

          <div class="btn_block">
            <a onClick={() => setStep(3)}>
              <img src={prev_arrow} alt="" /> <span>Prev</span>
            </a>
            <a onClick={handleNext} class="nxt_btn">
              <span>Next</span> <img src={next_arrow} alt="" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Step4;